module.exports = __webpack_public_path__ + "static/media/tick-inside-circle.7611e71f.svg";